import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from '../../auth/auth.guard';
import { MasterResolver } from '../master/master.resolver';

import { TractosComponent } from './tractos.component';
import { TractoNoSelectedComponent } from './tracto-no-selected/tracto-no-selected.component';
import { TractoEditComponent } from './tracto-edit/tracto-edit.component';
import { TractoDetailsComponent } from './tracto-details/tracto-details.component';
import { BusinessGuard } from 'src/app/auth/business.guard';

const routes: Routes = [
  {
    path: ':business',
    canActivate: [AuthGuard, BusinessGuard],
    resolve: [MasterResolver],
    data: { breadcrumb: 'business' },
    children: [
      {
        path: 'tractos',
        component: TractosComponent,
        data: { breadcrumb: 'Tractos' },
        children: [
          { path: '', component: TractoNoSelectedComponent },

          {
            path: 'new',
            component: TractoEditComponent,
            data: { breadcrumb: 'Nuevo' },
          },

          {
            path: ':id',
            component: TractoDetailsComponent,
            data: { breadcrumb: 'Detalle' },
          },

          {
            path: ':id/edit',
            component: TractoEditComponent,
            data: { breadcrumb: 'Editar' },
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TractosRoutingModule {}
